<template>
  <div class="container">
    <!-- 保修详情信息 -->
    <div class="work-order-info">
      <div class="work-order-info-title">报修信息</div>
      <div class="work-order-info-content">
            <div class="work-order-info-content-left">
          <span>网吧名称：</span>
          <span>{{details.siteName}}</span>
        </div>
            <div class="work-order-info-content-left">
          <span>网吧地址:</span>
          <span>{{details.siteAddress}}</span>
        </div>
            <div class="work-order-info-content-left">
          <span>处理人:</span>
          <span>{{details.operationName}}</span>
        </div>
            <div class="work-order-info-content-left">
          <span>处理时间:</span>
          <span>{{details.operationDate}}</span>
        </div>
        <div class="work-order-info-content-left">
          <span>报修类型：</span>
          <span>{{details.content}}</span>
        </div>
        <div class="work-order-info-content-left">
          <span>申请时间：</span>
          <span>{{details.applyDate}}</span>
        </div>
        <div class="work-order-info-content-left">
          <span>申请人：</span>
          <span>{{details.userName}}</span>
        </div>
        <div class="work-order-info-content-left">
          <span>联系人：</span>
          <span>{{details.name}}</span>
        </div>
        <div class="work-order-info-content-left">
          <span>联系电话：</span>
          <span><a :href="'tel:'+ details.phone" style="color:#333333">{{details.phone}}</a></span>
        </div>
        <div class="work-order-info-content-left">
          <span class="more-title clearfix">问题描述：</span>
          <span class="more-content">{{details.description}}</span>
        </div>
            <div class="warranty-details-info-img">
          <div>上传图片：</div>
          <div v-if="pictureList.length">
            <img
              v-for="(item,index) in pictureList"
              :key="index"
              class="more-img"
              :src="item.url"
              alt
              srcset
              @click="HandleclickImg(index)" 
            />
          </div>
            <div v-else>
            <img
              class="no-img"
              src="@/images/noupload.png"
              alt
              srcset
            />
          </div>
          <!-- <span class="more-title" style="color:#999999;margin-left:0">上传图片</span>
          <img v-for="(item,index) in pictureList" :key="index" class="more-img" :src="item.url" alt srcset />-->
        </div>
      </div>
    </div>
    <!-- 展示处理方法 -->
    <div class="work-order-info" v-show="details.maintenanceStatus == 3">
      <div class="work-order-info-title">处理方法</div>
      <div
        class="work-order-info-content"
      > {{details.method}}</div>
    </div>
    <!-- 展示接单按钮 -->
    <div class="btn" v-show="details.maintenanceStatus == 0">
      <span @click="handleClickClose">关闭订单</span>
      <span @click="handlePickUpClick">接单</span>
    </div>
    <!-- 展示处理完毕 -->
    <div
      class="finished-btn"
      @click="handleGoPageMethods"
      v-show="details.maintenanceStatus == 1"
    >处理完毕</div>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { workorderDetails, workorderClose,workorderPickUp } from "@/api/workorder";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      details: "",
      maintenanceFormId:'',
      pictureList:[],
      ImagePreview:[],
      show:false,

    };
  },
  mounted() {
    this.maintenanceFormId = this.$route.query.maintenanceFormId;
    this.requestWorkorderDetails();
    if (window.history && window.history.pushState) {
      console.log(window.history)
      console.log(window.history.pushState)
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.fun, false); //false阻止默认事件
    }
  },
   destroyed(){
     window.removeEventListener('popstate', this.fun, false);//false阻止默认事件
   },
  methods: {
       fun() {
      if(this.show) {
         this.show = false
         this.imagepreview.close()
          history.pushState(null, null, document.URL);
      }else {
          // histroy.back()
          window.history.go(-1);
      }
    },
    //详情列表
    requestWorkorderDetails() {
      workorderDetails({ maintenanceFormId:this.maintenanceFormId }).then(res => {
        console.log(res)
        this.details = res.data;
        this.pictureList = res.data.pictureList
        res.data.pictureList.forEach(element => {
          console.log(element);
          this.ImagePreview.push(element.url);
        });
      });
    },
        //  点击接单
    handlePickUpClick() {
      Dialog.confirm({
        title: "确定接单"
      })
        .then(() => {
            // let maintenanceFormId = this.$route.query.maintenanceFormId;
            workorderPickUp({ maintenanceFormId: this.maintenanceFormId }).then(res=>{
                console.log(res)
                if(res.code == 200) {
                    this.requestWorkorderDetails();
                }
            })
        })
        .catch(() => {
          // on cancel
        });
    },
    // 关闭订单
    handleClickClose() {
      Dialog.confirm({
        title: "确定关闭接单"
      })
        .then(() => {
          workorderClose({ maintenanceFormId: this.maintenanceFormId }).then(res => {
            console.log(res);
            if(res.code == 200) {
                this.$router.go(-1)
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    //  处理完毕
    handleGoPageMethods() {
      let maintenanceFormId = this.$route.query.maintenanceFormId;
      this.$router.push({
        path: "/processmethod",
        query: {
          maintenanceFormId
        }
      });
    },
  HandleclickImg(index) {
    this.show = true;
    this.imagepreview = ImagePreview({
      images: this.ImagePreview,
      startPosition: index,
      onClose() {
            this.show = false
         }
    });
  }
}
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  // 保修信息
  .work-order-info {
    width: 350px;
    margin: 10px 13px;
    background-color: #ffffff;
    text-align: left;
    border-radius: 10px;
    .work-order-info-title {
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding-left: 15px;
      box-sizing: border-box;
      border-bottom: 1px solid #eeeeee;
      color: #404051;
      font-size: 16px;
      font-weight: bold;
    }
    .work-order-info-content {
      width: 100%;
      padding: 15px 15px;
      box-sizing: border-box;
      color: #404051;
      font-size: 14px;
      //  每一行的信息
      .work-order-info-content-left {
        position: relative;
        margin: 15px 0;
        span {
          &:first-child {
            display: inline-block;
            width: 85px;
            padding: 5px;
            box-sizing: border-box;
            color: #999999;
          }
          &:last-child {
            display: inline-block;
            width: 203px;
            color: #333333;
            margin-left: 30px;
          }
        }
        .more-img {
          width: 60px;
          height: 60px;
          margin-right: 5px;
          &:first-of-type {
            margin-left: 117px !important;
          }
        }

        .more-title {
          display: inline-block;
          width: 85px;
          padding: 5px;
          position: absolute;
          top: 0;
        }
        .more-content {
          margin-top: 5px;
          margin-left: 117px !important;
        }
      }
      .warranty-details-info-img {
        display: flex;
        margin-top: 30px;
        div {
          &:first-child {
            width: 110px;
            color: #999999;
            padding: 5px;
            box-sizing: border-box;
          }
          .more-img {
            width: 30px;
            height: 30px;
          }
          .no-img {
          width: 60px;
          height: 60px;
          margin-right: 5px;
        }
        }
      }
    }
  }
  //   接单按钮
  .btn {
    width: 350px;
    margin: 0 auto;
    span {
      display: inline-block;
      width: 150px;
      height: 44px;
      border: 1px solid #008cff;
      text-align: center;
      line-height: 44px;
      border-radius: 22px;
      font-size: 16px;
      font-weight: bold;
      color: #008cff;
      margin: 0px 10px;
      margin-top: 106px;
      margin-bottom: 10px;
      &:hover {
        background: -webkit-linear-gradient(left, #05aefc, #008cff);
        color: #ffffff;
      }
    }
  }
  // 处理完毕按钮
  .finished-btn {
    width: 350px;
    height: 44px;
    background: -webkit-linear-gradient(left, #05aefc, #008cff);
    margin: 0 auto;
    border-radius: 22px;
    font-size: 16px;
    color: $white-color;
    line-height: 44px;
    margin: 0 auto;
    margin-top: 106px;
    margin-bottom: 10px;
  }
}
</style>
